'use strict';

module.exports = require('./is-implemented')() ? Symbol : require('./polyfill');



/*****************
 ** WEBPACK FOOTER
 ** /Users/gaearon/p/react-devtools/~/es6-symbol/index.js
 ** module id = 8
 ** module chunks = 0
 **/